module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Clothes/Crown-743a9c38b43bc7170d3b8b7e5be9bb65.svg";